var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57146 2.85718C9.12375 2.85718 9.57146 3.30489 9.57146 3.85718V4.1429H14.4286V3.85718C14.4286 3.30489 14.8763 2.85718 15.4286 2.85718C15.9809 2.85718 16.4286 3.30489 16.4286 3.85718V4.1429H19.2858C20.3114 4.1429 21.1429 4.97438 21.1429 6.00004V9.85718V19.2858C21.1429 20.3114 20.3114 21.1429 19.2858 21.1429H4.71432C3.68866 21.1429 2.85718 20.3115 2.85718 19.2858V9.85718V6.00004C2.85718 4.97437 3.68865 4.1429 4.71432 4.1429H7.57146V3.85718C7.57146 3.30489 8.01918 2.85718 8.57146 2.85718ZM14.4286 6.1429V7.28575C14.4286 7.83803 14.8763 8.28575 15.4286 8.28575C15.9809 8.28575 16.4286 7.83803 16.4286 7.28575V6.1429H19.1429V8.85718H4.85718V6.1429H7.57146V7.28575C7.57146 7.83803 8.01918 8.28575 8.57146 8.28575C9.12375 8.28575 9.57146 7.83803 9.57146 7.28575V6.1429H14.4286ZM19.1429 10.8572H4.85718V19.1429H19.1429V10.8572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a0f5ffda.svg";
export { ForwardRef as ReactComponent };